import { render, staticRenderFns } from "./UserVerificationLogin.vue?vue&type=template&id=20b42f18&scoped=true"
import script from "./UserVerificationLogin.vue?vue&type=script&lang=js"
export * from "./UserVerificationLogin.vue?vue&type=script&lang=js"
import style0 from "./UserVerificationLogin.vue?vue&type=style&index=0&id=20b42f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b42f18",
  null
  
)

export default component.exports